import api from './api';

// ========================
// USER SERVICE
// ========================
export const userService = {
  create: (data) => api.post('/users', data),
  list: (params) => api.get('/users', { params }),
  get: (id) => api.get(`/users/${id}`),
  update: (id, data) => api.put(`/users/${id}`, data),
  updateProfile: (data) => api.put('/users/profile', data),
  updateLanguage: (language) => api.patch('/users/language', { language }),
  unlock: (id) => api.patch(`/users/${id}/unlock`),
  listSupervisors: () => api.get('/users/supervisors'),
  listClients: () => api.get('/users/clients'),
};

// ========================
// PROJECT SERVICE
// ========================
export const projectService = {
  create: (data) => api.post('/projects', data),
  list: (params) => api.get('/projects', { params }),
  get: (id) => api.get(`/projects/${id}`),
  update: (id, data) => api.put(`/projects/${id}`, data),
  changeStatus: (id, data) => api.patch(`/projects/${id}/status`, data),
  delegate: (id, data) => api.post(`/projects/${id}/delegate`, data),
  removeDelegation: (id) => api.delete(`/projects/${id}/delegate`),
};

// ========================
// MASTER DATA SERVICE
// ========================
export const labourService = {
  create: (data) => api.post('/master-data/labour', data),
  list: (params) => api.get('/master-data/labour', { params }),
  get: (id) => api.get(`/master-data/labour/${id}`),
  update: (id, data) => api.put(`/master-data/labour/${id}`, data),
  delete: (id) => api.delete(`/master-data/labour/${id}`),
};

export const materialService = {
  create: (data) => api.post('/master-data/materials', data),
  list: (params) => api.get('/master-data/materials', { params }),
  get: (id) => api.get(`/master-data/materials/${id}`),
  update: (id, data) => api.put(`/master-data/materials/${id}`, data),
  delete: (id) => api.delete(`/master-data/materials/${id}`),
};

export const expenseCategoryService = {
  create: (data) => api.post('/master-data/expense-categories', data),
  list: (params) => api.get('/master-data/expense-categories', { params }),
  get: (id) => api.get(`/master-data/expense-categories/${id}`),
  update: (id, data) => api.put(`/master-data/expense-categories/${id}`, data),
  delete: (id) => api.delete(`/master-data/expense-categories/${id}`),
};

// ========================
// AUDIT LOG SERVICE
// ========================
export const auditLogService = {
  list: (params) => api.get('/audit-logs', { params }),
  get: (id) => api.get(`/audit-logs/${id}`),
};

// ========================
// CLIENT INVITE SERVICE
// ========================
export const clientInviteService = {
  list: (projectId) => api.get(`/projects/${projectId}/invites`),
  create: (projectId, data) => api.post(`/projects/${projectId}/invites`, data),
  revoke: (projectId, inviteId) => api.delete(`/projects/${projectId}/invites/${inviteId}`),
  validate: (token) => api.get(`/invites/${token}`),
  accept: (token, data) => api.post(`/invites/${token}/accept`, data),
};

// Task / Punch List
export const taskService = {
  list: (projectId, params) => api.get(`/projects/${projectId}/tasks`, { params }),
  get: (projectId, id) => api.get(`/projects/${projectId}/tasks/${id}`),
  create: (projectId, data) => api.post(`/projects/${projectId}/tasks`, data),
  update: (projectId, id, data) => api.put(`/projects/${projectId}/tasks/${id}`, data),
  delete: (projectId, id) => api.delete(`/projects/${projectId}/tasks/${id}`),
  summary: (projectId) => api.get(`/projects/${projectId}/tasks/summary`),
};

// Vendors
export const vendorService = {
  list: (params) => api.get('/vendors', { params }),
  get: (id) => api.get(`/vendors/${id}`),
  create: (data) => api.post('/vendors', data),
  update: (id, data) => api.put(`/vendors/${id}`, data),
  delete: (id) => api.delete(`/vendors/${id}`),
  rate: (id, data) => api.post(`/vendors/${id}/rate`, data),
};

// Alert Rules
export const alertService = {
  list: () => api.get('/alerts'),
  create: (data) => api.post('/alerts', data),
  update: (id, data) => api.put(`/alerts/${id}`, data),
  delete: (id) => api.delete(`/alerts/${id}`),
  evaluate: () => api.post('/alerts/evaluate'),
};
// ========================
export const csvImportService = {
  importLabour: (file) => { const fd = new FormData(); fd.append('file', file); return api.post('/master-data/import/labour', fd, { headers: { 'Content-Type': 'multipart/form-data' } }); },
  importMaterials: (file) => { const fd = new FormData(); fd.append('file', file); return api.post('/master-data/import/materials', fd, { headers: { 'Content-Type': 'multipart/form-data' } }); },
  importExpenseCategories: (file) => { const fd = new FormData(); fd.append('file', file); return api.post('/master-data/import/expense-categories', fd, { headers: { 'Content-Type': 'multipart/form-data' } }); },
};
